
import React, { Component } from 'react';
import $ from 'jquery';
import ahmedImg from "../images/ahmed.webp"
import ahmedMp4 from "../images/Ahmed.mp4"
import { database } from '../firebase';
export default class Testimonial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      testimonialData :[]
    }
  }
  componentDidMount() {
    this.renderList();
  }
  async renderList() {
    let dataList = []
    let dataListCategory = []
    await database.ref("testimonials").once('value', function (snapshot) {
      snapshot.forEach(
        function (ChildSnapshot) {
          if (ChildSnapshot.val().status == 'Active') {
            dataList.push({
              key: ChildSnapshot.key,
              testiAuthor: ChildSnapshot.val().author,
              testiImage: ChildSnapshot.val().imageUrl,
              testiVideo: ChildSnapshot.val().videoUrl,
            })
          }
        }
      )
    })
    this.setState({
      testimonialData: dataList,
      
    })
  }
  testimonialPopup(fileName){

    $('#upFileAboutVideoAdd').val(fileName);
    this.setState({
      videoTestimonial :fileName
    })
    $("body").addClass("modal-open");
    $("#testimonialPopup").addClass("show");
    $(".modal").show();
    $('.modal-backdrop').add(); 
    $("#testimonialPopup video").show();
    $('body').append('<div class="modal-backdrop fade show"></div>');    
   }
   closePopup(){
    this.setState({
      videoTestimonial :""
    })
    $('#upFileAboutVideoAdd').val("");
    $("body").removeClass("modal-open");
    $(".modal").removeClass("show");
    $(".modal").hide();
    $('.modal-backdrop').remove(); 
    $("#testimonialPopup video").hide();  
   }
    render() {

    return (

      <section className="testimonial-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="testimonial-panel"> 
                <div className="home-head"> Testimonial
                  <p>Our learners send us bunch of smiles with their experiences and we love them!</p>
                </div>
                <div className="testimonial-body">
                {this.state.testimonialData.map((data, i) => {
                  return(
                  <div className="testimonial-box">
                    <a className="testimonial-box-a"  onClick={() => this.testimonialPopup(data.testiVideo)}>
                    <img alt="" className="testimonial-img" src={data.testiImage} />
                      {/* <video style={{width:"100%"}} controls id={"videoRefAdd"}><source src={data.testiImage} id="upFileAboutVideoAdd" type="video/mp4" /></video> */}
                      <p className="testimonial-box-text">{data.testiAuthor}</p>
                    </a>
                  </div>
                  )
                })}
                </div>
              </div>
          </div>
        </div>
      </div>
      
      <div className="modal fade testPopup bd-example-modal-lg" id="testimonialPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"  onClick={() => this.closePopup()}>
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="modal-body text-center">
                  <video src={this.state.videoTestimonial} autoplay="autoplay" controls="controls" id="upFileAboutVideoAdd" controlslist="nodownload" ></video>
                </div>
              </div>
            </div>
          </div>
    </section>
      )
    }
}


// WEBPACK FOOTER //
// ./src/home/testimonial.jsx